
import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import LaunchButton from '@/components/LaunchButton';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

const DashboardPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <header className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-bold gradient-text">Krix AI Dashboard</h1>
        <LaunchButton variant="outline" onClick={handleLogout}>Log out</LaunchButton>
      </header>

      <div className="grid gap-6 md:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>Welcome, {user?.name || 'User'}!</CardTitle>
            <CardDescription>
              You're logged in to your Krix AI account
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-muted-foreground mb-4">
              Your account: <span className="font-medium text-foreground">{user?.email}</span>
            </p>
            <p className="text-sm text-muted-foreground">
              Plan: <span className="font-medium text-foreground">{user?.isPro ? 'Premium' : 'Free'}</span>
            </p>
          </CardContent>
          <CardFooter>
            {!user?.isPro && (
              <LaunchButton variant="cta" onClick={() => navigate('/pricing')}>
                Upgrade to Premium
              </LaunchButton>
            )}
          </CardFooter>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Quick Actions</CardTitle>
            <CardDescription>
              Start using Krix AI features
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <LaunchButton className="w-full" variant="outline">
              New Multi-Query Search
            </LaunchButton>
            <LaunchButton className="w-full" variant="outline">
              View Saved Searches
            </LaunchButton>
            <LaunchButton className="w-full" variant="outline">
              Account Settings
            </LaunchButton>
          </CardContent>
        </Card>
      </div>

      <p className="text-center text-sm text-muted-foreground mt-8">
        This is a placeholder dashboard. In a real implementation, this would be connected to your Krix AI service.
      </p>
    </div>
  );
};

export default DashboardPage;
